import React, { createContext, useContext } from 'react';

import { API_SCOPES } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import { useConfig } from '@/common/contexts/ConfigContext';
import useTheme from '@/common/hooks/useTheme';
import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';

const HeaderAccessesContext = createContext(null);

const HeaderAccessesContextProvider = ({ children }) => {
  const {
    user,
    accessEbc,
    accessPriceFile,
    showClearance,
    showDoc,
    showECatalog,
    showPromo,
  } = useAuth();
  const { partnerEnv } = useTheme();
  const { isChrono } = useConfig();
  const mixedCompany = ['CF', 'PS', 'SI'].includes(user?.company_code);

  return (
    <HeaderAccessesContext.Provider
      value={{
        carts: user?.functionality_accesses?.carts ?? false,
        cartsCreate: user?.functionality_accesses?.carts_create ?? false,
        cartsScandit: user?.functionality_accesses?.carts_scandit ?? false,
        infos: user?.functionality_accesses?.infos ?? false,
        partnerUnified:
          (user?.accesses?.EB && user?.accesses?.LM && mixedCompany) ?? false,
        orders: user?.functionality_accesses?.orders ?? false,
        partner:
          (user?.accesses?.[API_SCOPES?.[partnerEnv]] ?? false) &&
          (user?.functionality_accesses?.general_switch_EB_EBC ?? false) &&
          ((accessEbc || isChrono) ?? false),
        priceFile:
          (user?.functionality_accesses?.infos ?? false) &&
          (user?.functionality_accesses?.infos_price_file ?? false) &&
          (accessPriceFile ?? false),
        quotes: user?.functionality_accesses?.quotes ?? false,
        topProducts: user?.functionality_accesses?.top_products ?? false,
        wishlists: user?.functionality_accesses?.wishlists ?? false,
        worksites: user?.functionality_accesses?.worksites ?? false,
        showClearance: showClearance ?? false,
        showDoc: showDoc ?? false,
        showECatalog: showECatalog ?? false,
        showPromo: showPromo ?? false,
      }}
    >
      {children}
    </HeaderAccessesContext.Provider>
  );
};

HeaderAccessesContextProvider.defaultProps = {
  ...ChildrenDefaultProps,
};

HeaderAccessesContextProvider.propTypes = {
  ...ChildrenPropTypes,
};

export const useHeaderAccessesContext = () => useContext(HeaderAccessesContext);

export default HeaderAccessesContextProvider;
